import { SEARCH_CONFIG } from '../searchFlyoutConfig';
export const getFields = (inventory: keyof typeof SEARCH_CONFIG, dataType: string) =>
  inventory && dataType ? SEARCH_CONFIG[inventory][dataType] || [] : [];
